import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showMenu: false,
};

export const showMenuSlice = createSlice({
  name: "showMenu",
  initialState,
  reducers: {
    changeShowMenu: (state, action) => {
      state.showMenu = action.payload;
    },
  },
});

export const { changeShowMenu } = showMenuSlice.actions;

export default showMenuSlice.reducer;
